import { Box } from "@mantine/core";
import React from "react";
import { Stimulus, StimulusPosition } from "types/testTypes";

interface StimulusGridProps {
  stimuli: Stimulus[];
  style?: React.CSSProperties;
}

const getStyle = (position?: StimulusPosition) => {
  // If a specific position is provided, use it to determine grid placement
  if (position) {
    switch (position) {
      case "top":
        return { gridArea: "top", justifySelf: "center", alignSelf: "center" };
      case "left":
        return { gridArea: "left", justifySelf: "center", alignSelf: "center" };
      case "right":
        return { gridArea: "right", justifySelf: "center", alignSelf: "center" };
      default:
        return { gridArea: "center", justifySelf: "center", alignSelf: "center" };
    }
  }
  return { gridArea: "center", justifySelf: "center" };
};

const StimulusGrid: React.FC<StimulusGridProps> = ({ stimuli, style }) => {
  return (
    <Box
      display={"grid"}
      style={{
        gridTemplateAreas: `
          ".     top     ."
          "left center right"
          ".      .      ."
        `,
        gridTemplateColumns: "1fr 1fr 1fr",
        gridTemplateRows: "1fr 1fr 1fr",
        placeItems: "center",
        ...style,
      }}
    >
      {stimuli?.map((stimulus, index) => {
        const imageName = stimulus.imageName;
        const style = getStyle(stimulus.position);
        if (!imageName) return null;

        const src = `/img/${imageName}.png`;
        return (
          <Box key={`${stimulus.id}-${index}`} w="100" h="100" style={style}>
            <img
              src={src}
              alt={imageName}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
                ...style,
              }}
            />
          </Box>
        );
      })}
    </Box>
  );
};

export default StimulusGrid;
